import React, { useMemo, useContext } from 'react';
import { useQueryClient } from 'react-query';
import cn from 'classnames';
import RoundIconBackground from '../RoundIconBackground/RoundIconBackground';
import { roundIconBgTypes, mainContainerId } from '../../constants/common';
import { ReactComponent as CallIcon } from '../../../../resource/CallIcon.svg';
import { sipStatusState } from '../../constants/sipStatusState';
import { SipPhoneContext } from '../../../../components/SipPhoneProvider';
import { phoneQueryKeys } from '../../queries/queryKeys';
import styles from './PhoneBtn.module.scss';

const PhoneBtn = ({ onClick }) => {
  const { sip } = useContext(SipPhoneContext);

  const queryClient = useQueryClient();

  const calls = queryClient.getQueryData(phoneQueryKeys.calls());
  const activeCalls = calls?.activeCalls;

  const roundIconBgType = useMemo(() => {
    return activeCalls?.length
      ? roundIconBgTypes.hasActiveCalls
      : sipStatusState[sip.status].containerType || roundIconBgTypes.call;
  }, [sip.status, activeCalls]);

  const roundIconBgTooltip = useMemo(() => {
    return activeCalls?.length
      ? 'Есть входящие звонки'
      : sipStatusState[sip.status].tooltip;
  }, [sip.status, activeCalls]);

  return (
    <RoundIconBackground
      renderIcon={({ className }) => <CallIcon className={className} />}
      size="extraLarge"
      onClick={onClick}
      containerType={roundIconBgType}
      tooltipTitle={roundIconBgTooltip}
      getTooltipContainer={() => document.getElementById(mainContainerId)}
      loading={sipStatusState[sip.status].loading}
      className={cn({ [styles.hasActiveCalls]: activeCalls?.length })}
    />
  );
};

export default PhoneBtn;
